module.exports = __webpack_public_path__ + "static/assets/background.fb65f28e.jpg";